import script from "./Button.vue?vue&type=script&lang=ts&setup=true"
export * from "./Button.vue?vue&type=script&lang=ts&setup=true"

import "./Button.vue?vue&type=style&index=0&id=7725c008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7725c008"]])

export default __exports__